module.exports = __webpack_public_path__ + "static/media/moment04.d6a39c63.webp";